import React from 'react';
import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyExpenses } from 'api/expenses/use-get-many-expenses.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { useInitFiltersFromUrl } from 'shared/hooks/use-init-filters-from-url';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params.ts';
import { useExpensesFiltersStore, type IExpensesFilter } from 'shared/stores/use-expenses-filters.ts';
import { ExpenseCreate } from 'components/expenses/expense-create';
import { ExpensesFilter } from 'components/expenses/expenses-filter';
import { ExpensesList } from 'components/expenses/expenses-list';
import { ExpensesSummary } from 'components/expenses/expenses-summary';
import { Pagination } from 'components/pagination';

export const ExpensesListPageComponent: React.FC = () => {
  const { page, limit, handlePageChange } = usePaginationParams();
  const { search, filters, setFilters } = useExpensesFiltersStore();
  const { data: expenses, isLoading, isPreviousData } = useGetManyExpenses({ page, limit, search, filters });

  useInitFiltersFromUrl<IExpensesFilter>({ schema: { overdue: 'boolean' }, setFilters });
  usePageReset([search, filters]);

  const header = <PageHeader title={<ExpensesFilter />} extra={[<ExpenseCreate key='create' />]} />;

  return (
    <DefaultPageLayout header={header}>
      <Skeleton loading={isLoading}>
        <ExpensesSummary />
        <ExpensesList expenses={expenses?.data || []} isLoading={isPreviousData} />
        <Pagination
          total={expenses?.pagination?.total}
          page={expenses?.pagination?.currentPage}
          limit={expenses?.pagination?.limit}
          onChange={handlePageChange}
        />
      </Skeleton>
    </DefaultPageLayout>
  );
};
export const ExpensesListPage = withRoleGuard(ExpensesListPageComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
